import {
  SERIES_PRODUCT_ORDER_FAILED,
  SERIES_PRODUCT_ORDER_REQUEST,
  SERIES_PRODUCT_ORDER_SUCCESS,
} from "app/redux/actions/Order/SeriesProductOrder/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const SeriesProductOrderReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case SERIES_PRODUCT_ORDER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case SERIES_PRODUCT_ORDER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case SERIES_PRODUCT_ORDER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
